export function etaSecondsToMinutes(seconds: number | null | undefined): number | null {
  if (seconds == null || seconds <= 0) return null;
  return Math.max(1, Math.ceil(seconds / 60));
}
